import { useIntl } from 'react-intl';
import { Icon } from '@amzn/awsui-components-react';

import { IdPs } from '../constants/providers';
import providerMessages from '../i18n/provider.messages';
import { IdProvider } from '../types/auth';
import ChoiceButton from './ChoiceButton';
import lwaIcon from '../assets/lwa.svg';
import styles from './ProviderButton.module.css';

const ProviderButton = ({
  provider,
  onClick,
  ...props
}: {
  provider: IdProvider;
  onClick: Function;
}) => {
  const { formatMessage } = useIntl();

  // Currently only LWA has special treatment, a one off. If this becomes a
  // pattern for other providers as well another mechanism will be needed here.
  const isLWA = provider.idp === IdPs.LoginWithAmazon;

  return (
    <ChoiceButton
      onClick={() => onClick(provider)}
      data-testid="signin-providerButton"
      className={isLWA ? styles.lwa : ''}
      id={`${provider.idp}-provider-button`}
      {...props}
    >
      {isLWA && (
        <span className={styles.icon}>
          <Icon url={lwaIcon} alt="" />
        </span>
      )}
      {IdPs[provider.idp as IdPs]
        ? formatMessage(providerMessages[provider.idp as IdPs])
        : provider.idp}
    </ChoiceButton>
  );
};

export default ProviderButton;
